<template>
    <v-container fluid class="pa-0 px-3">
        <loading
            :active.sync="loading"
            :can-cancel="false"
            :is-full-page="true"
            :height="150"
            :width="150"
            :color="'#FFFF00'"
            :background-color="'#000000'"
            :opacity="0.5"
        ></loading>

        <!-- Sticky: buttons -->
        <div style="position:sticky;top:0;z-index:20;background:#ffffff;padding:0;">
            <div class="review-btn-bar">
                <v-btn class="fbtn fbtn-cancel mr-2" @click="backHandler">
                    <v-icon size="16" class="mr-1">mdi-arrow-left</v-icon>
                    {{$t('button.back')}}
                </v-btn>
            </div>
        </div>

        <!-- White inner card -->
        <div class="review-main-card">
            <!-- Info card: full width, compact -->
            <v-card outlined class="info-card mb-3">
                <v-card-text class="py-1 px-3">
                    <v-row dense class="info-row">
                        <v-col cols="2" class="info-label">{{$t('appraisalrecord.review')}}</v-col>
                        <v-col cols="10" class="info-value">{{ parentObject.review.reviewname }}</v-col>
                    </v-row>
                    <v-row dense class="info-row">
                        <v-col cols="2" class="info-label">{{$t('columns.staff')}}</v-col>
                        <v-col cols="10" class="info-value">{{ parentObject.review.staffname }} - {{ parentObject.review.staffcode }}</v-col>
                    </v-row>
                    <v-row dense class="info-row">
                        <v-col cols="2" class="info-label">{{$t('columns.period')}}</v-col>
                        <v-col cols="10" class="info-value"><b>{{ parentObject.review.startdate }}</b> until <b>{{ parentObject.review.enddate }}</b></v-col>
                    </v-row>
                    <v-row dense class="info-row">
                        <v-col cols="2" class="info-label">{{$t('appraisalrecord.reviewer')}}</v-col>
                        <v-col cols="10" class="info-value">{{ parentObject.review.reviewername }} - {{ parentObject.review.reviewercode }}</v-col>
                    </v-row>
                </v-card-text>
            </v-card>

            <div v-if="sectionCard">
                <div v-for="(item, index) in filteredSectionList" :key="index">
                    <app-sectioncard
                        @update-scorablesection-score="handleScorableScore"
                        @update-objectivesection-score="assignObjectiveSectionScore"
                        @update-scorablesection-rating="assignScorableItemListandRating"
                        v-bind:parentObject="{
                            review: parentObject.review,
                            formData: item,
                            indKPIData: indKPIData,
                            method: parentObject.review.method,
                            isWizard: item.isWizard,
                            totalSectWeightage: totalSectWeightage,
                            DelegatedWFTranDetails: DelegatedWFTranDetails,
                        }"
                    />
                </div>
            </div>

            <div class="final-score-bar">
                <span class="final-score-label">{{$t('pmassementrecord.finalscore')}}</span>
                <span class="final-score-value">
                    {{ totalScore }}<span v-if="weightingUnit === 'P'">%</span>
                </span>
            </div>

        </div><!-- end review-main-card -->

        <v-dialog v-model="showConfirmDialog" max-width="400">
        <v-card>
            <v-card-title class="text-h6">Confirm Action</v-card-title>
            <v-card-text class="text-body-1" style="font-size: 1.1rem; line-height: 1.6; color: #000;">
            Do you want to <strong class="success--text">APPROVE</strong> or <strong class="error--text">SEND BACK</strong> Review to previous reviewer?
            </v-card-text>
            <v-card-actions class="py-4" style="font-size: 1.15rem;">
            <v-spacer></v-spacer>
            <v-btn color="warning" text style="font-size: 1.05em;" @click="showConfirmDialog = false">Cancel</v-btn>
            <v-btn color="error" text style="font-size: 1.05em;" @click="showConfirmDialog = false; sendBackAction()">Send Back</v-btn>
            <v-btn color="success" text style="font-size: 1.05em;" @click="showConfirmDialog = false; approveAction()">Approve</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

        <v-dialog v-model="showHandleWorkflowDialog" max-width="600">
        <v-card>
            <v-card-title class="text-h6">Ooops...</v-card-title>
            <v-card-text class="text-body-1" style="font-size: 1.1rem; line-height: 1.6; color: #000;">
            It seems that you do not have a role assignment for next level reviewer.<br> Do you want to <strong class="success--text">SUBMIT TO NEXT PERSON</strong> or <strong class="error--text">END WORKFLOW</strong>?
            </v-card-text>
            <v-card-actions class="py-4" style="font-size: 1.15rem;">
            <v-spacer></v-spacer>
            <v-btn color="warning" text style="font-size: 1.05em;" @click="showHandleWorkflowDialog = false">Cancel</v-btn>
            <v-btn color="error" text style="font-size: 1.05em;" @click="showHandleWorkflowDialog = false; endWorkflow()">End Workflow</v-btn>
            <v-btn color="success" text style="font-size: 1.05em;" @click="showHandleWorkflowDialog = false; addAndsubmitToNextPerson()">Submit to Next Person</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

        <v-dialog v-model="addAndSendToNextReviewerDialog" max-width="900px">
          <v-card>
            <v-card-text>
                <v-container>
                    <v-row class="ml-n6">
                        <v-col cols="12">
                            <span style="font-weight: bold;">
                            {{ $t('pmselfservice.sendtonextreviewer') }} &nbsp;
                            </span>
                        </v-col>
                    </v-row>
                    <div>
                        <v-row class="pb-n4 mb-n4 mt-2">
                            <v-autocomplete
                                outlined
                                :label="$t('columns.name')"
                                type="text"
                                v-model="nextReviewer.staffid"
                                dense
                                :items="staffList"
                                @change="changeStaff(nextReviewer.staffid)"
                            ></v-autocomplete>
                        </v-row>

                        <v-row class="mt-n8 mb-n16">
                            <v-col cols="4" class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.staffno')"
                                    type="text"
                                    v-model="nextReviewer.staffcode"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="4" class="pl-0">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.company')"
                                    type="text"
                                    v-model="nextReviewer.staffcompany"
                                    dense
                                    class="v-input"
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </div>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="addAndSendToNextReviewer">{{$t('button.send')}}</v-btn>
              <v-btn color="red darken-1" text @click="addAndSendToNextReviewerDialog = false">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <div v-if="isErr">
        <app-error
            v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
            }"
            v-on:closeError="isErr = $event"
        />
        </div>
        <div v-if="isSuccess">
        <app-success
            v-bind:parentObject="{
                messageSuccess: this.successMsg,
                isSuccess: this.isSuccess,
            }"
            @close-success="goBackToMyTask"
        />
        </div>
    </v-container>
</template>

<script>

import SectionCard from "./SectionCard";
import ErrorDialog from "@/components/common/ErrorDialog.vue";
import SuccessDialog from "@/components/common/SuccessDialog";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {

    props: {
        parentObject: Object,
    },

    components: {
        "app-error": ErrorDialog,
        'app-sectioncard': SectionCard,
        'app-success': SuccessDialog,
        Loading,
    },



    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            loading: false,
            DelegatedWFTranDetails: [],
            showConfirmDialog: false,

            indKPIData: {
                pmreviewexerciseid: this.parentObject.review.pmreviewexerciseid,
                staffid: this.parentObject.review.staffid, 
                reviewerid: this.parentObject.review.reviewerid,
            },

            sectionList: [],
            sectionTypeList: [],
            sectionCard: false,

            scorableSectionScores: {}, // key = section id, value = score
            objectiveSectionScore: 0,
            scorableSectionRatingList: [],
            reviewerList: [],
            rankMapSetDetails: [],
            totalSectWeightage: 0,
            weightingUnit: null,
            workflowRoles: [],
            showHandleWorkflowDialog: false,
            addAndSendToNextReviewerDialog: false,
            nextReviewer: {
                staffid: null,
                staffcode: '',
                staffcompany: '',
            },
            staffList: [],
            staffFull: [],

            isDraft: false,

            isErr: false,
            errMsg: '',
            isSuccess: false,
            successMsg: '',
            isEdit: false,
        };
    },

    computed: {
        objectiveSectweightage() {
            const objectiveSection = this.sectionList.find(
                section => section.sectionname === "Objective"
            );
            return objectiveSection ? parseFloat(objectiveSection.sectmaxscore).toFixed(2) : "0.00"; // Default to 0 if not found
        },

        scorableSectweightage() {
            // Filter all sections with name "Scorable Section"
            const scorableSections = this.sectionList.filter(
                section => section.sectionname === "Scorable Section"
            );

            // Sum up sectmaxscore
            const total = scorableSections.reduce((sum, section) => {
                return sum + parseFloat(section.sectmaxscore || 0);
            }, 0);

            // Return with 2 decimal places
            return total.toFixed(2);
        },

        //Total of all scorable section scores
        totalScorableSectionScore() {
            return Object.values(this.scorableSectionScores)
                        .reduce((sum, val) => sum + parseFloat(val || 0), 0)
                        .toFixed(2);
        },
        
        totalScore() {
            return (
                parseFloat(this.objectiveSectionScore || 0) + 
                parseFloat(this.totalScorableSectionScore || 0)
            ).toFixed(2); // Ensure 2 decimals
        },
        totalSectweightage() {
            return (
                parseFloat(this.objectiveSectweightage || 0) + 
                parseFloat(this.scorableSectweightage || 0)
            ).toFixed(2); // Ensure 2 decimals
        },

        filteredSectionList() {
            const staffId = this.$store.getters.staffId;
            return this.sectionList.filter(item => {
                // Skip if pmdisplayoption is "Exclude Staff" AND current staff matches
                return !(item.pmdisplayoption === 'Exclude Staff' && staffId === this.parentObject.review.staffid);
            });
        }
    },

    methods: {
        goBackToMyTask() {
            this.isSuccess = false;
            this.$router.push({ name: "selfservicemytask" });
        },

        submitHandler(){
            console.log("Submitting Review Form");
            console.log("DELEGATED", this.DelegatedWFTranDetails);
            console.log("SCORABLELIST", this.scorableSectionRatingList);
            if(this.scorableSectionRatingList.length === 0){
                this.isErr = true;
                this.errMsg = "Please review all the scorable sections before submitting.";
                return;
            }
            if (this.DelegatedWFTranDetails[0].sequenceno === 0) {
                // Directly approve without dialog
                this.approveAction();
            } else {
                this.showConfirmDialog = true;
            }
        },

        approveAction(){
            //save Score
            const vm = this;

            const workflowRoles = vm.workflowRoles.length;
            const totalLevel = vm.DelegatedWFTranDetails[0].totallevel;
            const currentLevelNo = vm.DelegatedWFTranDetails[0].lvlno;

            // Not enough role assignments 
            const isMissingRole = workflowRoles !== totalLevel;

            // "Before missing level" means current level equals workflowRoles
            const isLevelBeforeMissing = currentLevelNo === workflowRoles;

            console.log("workflowRoles", workflowRoles);
            console.log("totalLevel", totalLevel);
            console.log("currentLevelNo", currentLevelNo);  
            console.log("isMissingRole", isMissingRole);
            console.log("isLevelBeforeMissing", isLevelBeforeMissing);

            // If not enough role assignments AND is level before missing and have wfsetupdid, handle workflow
            if (isMissingRole && isLevelBeforeMissing && this.parentObject.review.wfsetupdid) {
                console.log("Don't have enough role assignments");
                this.showHandleWorkflowDialog = true;
            } else{
                // Convert score to number before sending
                const finalScore = parseFloat(this.totalScore);

                this.$store.dispatch('put', {url: "/reviewexercisestaff/reviewer/score/" + this.parentObject.review.reviewstaffreviewerid + "/" + finalScore})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        // vm.errMsg = res.data.error;
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        console.log("SAVE SCORE SUCCESS");
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });


                //Submit Workflow Transaction
                //pmreviewstaffreviewer id, staff id and pmreviewexercisedid
                const selectedData = {
                    pmreviewexercisedid: this.parentObject.review.pmreviewexercisedid,
                    staffid: this.$store.getters.staffId,
                    pmreviewstaffreviewerid: this.parentObject.review.reviewstaffreviewerid,
                };

                console.log("Selected Data", selectedData);
                
                this.$store.dispatch('post', {url: "/ss/review/submit", payload: selectedData})
                .then((res) => {
                    if (res.data.error) {
                        vm.isErr = true;
                        // vm.errMsg = res.data.error;
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        console.log("SUCCESS");
                        vm.successMsg = "Review submitted successfully.";
                        this.saveScorableRating();
                    }
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err.message || err;
                });
            }
        },

        addAndsubmitToNextPerson(){
            console.log("Submitting to Next Person");
            this.addAndSendToNextReviewerDialog = true;
        },

        addAndSendToNextReviewer(){
            console.log("Sending to Next Reviewer");
            const vm = this;

            const nextLvlno = vm.DelegatedWFTranDetails[0].lvlno + 1;
            const nextSequenceno = vm.DelegatedWFTranDetails[0].sequenceno + 1;

            const selectedData = {
                pmreviewexercisedid: this.parentObject.review.pmreviewexercisedid,
                nextApproverID: this.nextReviewer.staffid,
                currentStaffID: this.$store.getters.staffId,
                nextLvlno: nextLvlno,
                wftranid: this.DelegatedWFTranDetails[0].wftranid,
                wftrandid: this.DelegatedWFTranDetails[0].id,
                nextSequenceno: nextSequenceno,
            };

            console.log("Selected Data", selectedData);

            this.$store.dispatch('put', {url: "/ss/review/addandsubmit", payload: selectedData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    // vm.errMsg = res.data.error;
                    vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                } else {
                    vm.successMsg = "Review submitted to next reviewer successfully.";
                    this.saveScorableRating();
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
        },

        endWorkflow(){
            console.log("Ending Workflow");
            const vm = this;
            const selectedData = {
                pmreviewexercisedid: this.parentObject.review.pmreviewexercisedid,
                staffid: this.$store.getters.staffId,
                pmreviewstaffreviewerid: this.parentObject.review.reviewstaffreviewerid,
                wftrandid: this.DelegatedWFTranDetails[0].id,
                wftranid: this.DelegatedWFTranDetails[0].wftranid,
            };

            this.$store.dispatch('put', {url: "/ss/review/endworkflow", payload: selectedData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    // vm.errMsg = res.data.error;
                    vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                } else {
                    vm.successMsg = "Workflow ended successfully.";
                    this.saveScorableRating();
                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
        },

        sendBackAction(){
            //Send reviewstaffreviewer and sequenceno

            const selectedData = {
                recordid: this.parentObject.review.reviewstaffreviewerid,
                sequenceno: this.DelegatedWFTranDetails[0].sequenceno,
                currentStaffID: this.$store.getters.staffId
            };

            console.log("Selected Data", selectedData);
            const vm = this;

            this.$store.dispatch('post', {url: "/ss/review/submit/sendback", payload: selectedData})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    // vm.errMsg = res.data.error;
                    vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                } else {
                    //Success
                    //Send to MyTask page with update MyTask list
                    console.log("SUCCESS");
                    vm.isSuccess = true;
                    vm.successMsg = "Review sent back successfully.";
                    this.goBackToMyTask();

                }
            })
            .catch((err) => {
                vm.isErr = true;
                vm.errMsg = err.message || err;
            });
        },

        saveDraft(){
            this.isDraft = true;
            this.saveScorableRating();
        },

        async saveScorableRating(){
            const vm = this;

            const reviewerId = this.parentObject.review.reviewstaffreviewerid;

            this.scorableSectionRatingList = this.scorableSectionRatingList.map(item => {
                return {
                    ...item, // keep existing fields
                    reviewstaffreviewerid: reviewerId, // add/update this field
                    staffid: this.$store.getters.staffId,
                    isDraft: this.isDraft ? this.isDraft : null
                }
            });

            if(this.scorableSectionRatingList.length === 0){
                vm.isErr = true;
                vm.errMsg = "Please review all the scorable sections before submitting.";
                return;
            }

            console.log("Scorable Section Rating List to be saved:", this.scorableSectionRatingList);

            const scorableData = {
                scorableSectionRatingList: this.scorableSectionRatingList,
                isDraft: this.isDraft ? this.isDraft : false,
            };

            try {
                const res = await this.$store.dispatch('post', {url: "/reviewexercise/scorable/rating", payload: scorableData});
                if (res.data.error) {
                    vm.isErr = true;
                    if (Array.isArray(res.data.error)) {
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.errMsg = res.data.error;
                    }
                } else {
                    console.log("Saved Scorable Rating");

                    if (!this.isDraft) {
                        const individualScore = await this.getIndividualScore();
                        console.log("INDIVIDUALSCORE", individualScore);

                        const rank = await this.determineRank(individualScore);
                        console.log("RANK", rank);

                        this.setStaffReviewExerciseScoreandRank(individualScore, rank);
                    }else{
                        vm.successMsg = "Draft saved successfully.";
                        vm.isSuccess = true;
                    }
                    // this.$router.push({ name: 'selfservicemytask' });
                }
            } catch (err) {
                console.error("Error saving rating:", err);
                vm.isErr = true;
                vm.errMsg = "Failed to save rating.";
            }
        },

        setStaffReviewExerciseScoreandRank(score, rank){
            const vm = this;

            this.$store.dispatch('put', {url: "/reviewexercise/staff/" + vm.parentObject.review.pmreviewexercisedid + "/" + score + "/" + rank})
            .then((res) => {
                if (res.data.error) {
                    vm.isErr = true;
                    if (Array.isArray(res.data.error)) {
                        vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                    } else {
                        vm.errMsg = res.data.error;
                    }
                } else {
                    vm.isSuccess = true;
                    // vm.$router.push({ name: "reviewexercisestaffreviewer", params: { id: vm.formData.pmreviewexercisedid, formData: vm.formData, item: vm.formData} });
                }
            })
        },

        getIndividualScore() {
            const vm = this;

            return this.$store.dispatch('get', { url: "/reviewexercisestaff/reviewer/" + vm.parentObject.review.pmreviewexercisedid })
                .then((res) => {
                    vm.reviewerList = res.data.rec;

                    // Calculate the sum of factors
                    const totalFactor = vm.reviewerList.reduce((sum, record) => sum + record.factor, 0);

                    // Calculate the weighted average score
                    const totalScore = vm.reviewerList.reduce((sum, record) => {
                        const weightedScore = (record.factor / totalFactor) * record.score;
                        return sum + weightedScore;
                    }, 0);

                    return totalScore;
                })
                .catch((err) => {
                    console.error(err);
                    throw err; // Ensure the error propagates
                });
        },

        async determineRank(score) {
            console.log("SCORE", score);
            const rankMapSetDetails = await this.loadRankMapSetDetails();

            // Make sure details are sorted by uptoscore ascending
            rankMapSetDetails.sort((a, b) => a.uptoscore - b.uptoscore);

            // Find the first rank where score <= uptoscore
            const found = rankMapSetDetails.find(detail => score <= detail.uptoscore);
            console.log("FOUND", found);

            if (found) {
                return found.rank; // return the rank
            } else {
                // If score is higher than all uptoscore, return the last rank
                return rankMapSetDetails[rankMapSetDetails.length - 1]?.rank || null;
            }
        },

        //keeping for future use
        async loadRankMapSetDetails() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', { 
                    url: "/rankmapsetdetails/" + vm.parentObject.review.pmrankmapsetid 
                });

                vm.rankMapSetDetails = res.data.rec; // Set the details
                return vm.rankMapSetDetails; // Return the data if needed
            } catch (err) {
                console.error(err);
                throw err; // Rethrow the error to handle it in the calling code
            }
        },

        handleScorableScore({ id, score }) {
            this.assignScorableSectionScore(id, score);
        },

        assignScorableSectionScore(id, score) {
            this.$set(this.scorableSectionScores, id, score); // reactive update
        },

        assignObjectiveSectionScore(score) {
            this.objectiveSectionScore = score; 
        },

        //handle scorable items for more than one section
        assignScorableItemListandRating(itemlist) {
            // 1. Create a map of incoming items
            const incomingMap = new Map(
                itemlist.map(item => [item.id, item])
            );

            // 2. Build a new array by merging existing items
            const updatedList = [];

            for (const oldItem of this.scorableSectionRatingList) {
                const newItem = incomingMap.get(oldItem.id);

                if (newItem) {
                    // Replace old item (only if scorableRating !== 0)
                    if (newItem.scorableRating !== 0) {
                        updatedList.push({ ...newItem });
                    }
                    // Remove from map after processing
                    incomingMap.delete(oldItem.id);
                } else {
                    // Keep old item (only if scorableRating !== 0)
                    if (oldItem.scorableRating !== 0) {
                        updatedList.push(oldItem);
                    }
                }
            }

            // 3. Add any remaining new items (not seen before)
            for (const newItem of incomingMap.values()) {
                if (newItem.scorableRating !== 0) {
                    updatedList.push({ ...newItem });
                }
            }

            // 4. Replace the array reactively
            this.scorableSectionRatingList = updatedList;
        },


        backHandler(){
            const vm = this;
            this.$router.push({ name: 'selfservicemystaffdetails', params: { list: vm.parentObject.list, roleName: vm.parentObject.roleName } });
        },

        loadItemSection() {
            const vm = this;

            this.$store.dispatch('get', { url: "/reviewformsection/" + vm.parentObject.review.reviewformid })
                .then((res) => {
                    vm.sectionList = res.data.rec;
                    if (vm.sectionList.length > 0) {
                                       
                        for (let i = 0; i < vm.sectionList.length; i++) {
                            vm.sectionList[i].isWizard = true;
                            this.assignSectionName(vm.sectionList[i].pmsectiontypeid, i);
                        }

                        // calculate total sectweightage
                        vm.totalSectWeightage = vm.sectionList.reduce((sum, item) => {
                            return sum + (parseFloat(item.sectweightage) || 0);
                        }, 0);

                        // add sectmaxscore to each item
                        vm.sectionList.forEach(item => {
                            const sectWeightage = parseFloat(item.sectweightage) || 0;
                            const maxScore = parseFloat(item.maxscore) || 0;
                            item.sectmaxscore = vm.totalSectWeightage > 0 ? (sectWeightage / vm.totalSectWeightage) * maxScore : 0;
                            console.log("sectname", item.sectname);
                            console.log("sectmaxscore", item.sectmaxscore);
                        });

                        vm.weightingUnit = vm.sectionList[0].weightingunit;

                        vm.sectionCard = true;
                    }

                    console.log("Section List: ", vm.sectionList);
                }).catch((err) => {
                    console.error(err);
                });
        },

        loadSectionType(){
            const vm = this;
            
            return this.$store.dispatch('get', { url: "/reviewform/sectiontype/all"})
                .then((res) => {
                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.sectionTypeList.push({
                            id: res.data.rec[i].id,
                            description: res.data.rec[i].description,
                        });
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        },

        assignSectionName(id, index) {
            const section = this.sectionTypeList.find(section => section.id === id);
            this.sectionList[index].sectionname = section ? section.description : null;
        },

        loadDelegatedWFTranDetails() {
            const vm = this;
            this.$store.dispatch('get', { url: '/ss/delegated/wftrand/' + this.parentObject.review.reviewstaffreviewerid + "/" + this.$store.getters.staffId })
                .then((res) => {
                    vm.DelegatedWFTranDetails = res.data.rec;
                    console.log("DelegatedWFTranDetails: ", vm.DelegatedWFTranDetails);
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        loadWorkflowRoles() {
            const vm = this;
            this.$store.dispatch('get', { url: '/ss/workflow/roles/' + this.parentObject.review.pmreviewexercisedid + '/' + this.parentObject.review.staffid})
                .then((res) => {
                    vm.workflowRoles = res.data.rec;
                    console.log("Workflow Roles: ", vm.workflowRoles);
                })
                .catch((err) => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        loadStaffList(){
            const vm = this;
            const today = new Date();

            this.$store.dispatch('get', {url: "/staff/all/" + this.$store.getters.userId})
            .then((res) => {

                const staffRecords = res.data.rec;

                // Filter staff records where cessadate > today's date
                const filteredStaff = staffRecords.filter(staff => {
                    const cessadate = new Date(staff.cessadate);
                    return cessadate > today;
                });

                vm.staffFull = filteredStaff;

                // Populate staffList with the filtered data
                vm.staffList = filteredStaff.map(staff => ({
                    text: staff.psndetails,
                    value: staff.id,
                }));
                
            }).catch((err) => {
                console.error(err)
            });

        },

        changeStaff(id) {
            let item = this.staffFull.find((item) => item.id === id);
            this.nextReviewer.staffcode = item?.staffcode ?? null;
            this.nextReviewer.staffcompany = item?.compnycode ?? null;
        },
    },

    mounted() {
        console.log("Review:", this.parentObject.review);
        this.loading = true;
        this.loadSectionType()
        .then(() => {
            this.loadItemSection();
            this.loadDelegatedWFTranDetails();
            this.loadWorkflowRoles();
            this.loadStaffList();
        })
        .catch((err) => {
            console.error("Error loading section types:", err);
        })
        .finally(() => {
            this.loading = false;
        });
    },    
};

</script>

<style>
.v-expansion-panel-header .v-icon.mdi-chevron-down.theme--light {
    color: white !important;
}</style>

<style scoped>
.review-btn-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 16px 0 8px 0;
}

.review-main-card {
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #E8EDF5;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    padding: 16px 20px 32px 20px;
    margin-top: 4px;
    margin-bottom: 24px;
    overflow-y: auto;
    max-height: calc(100vh - 120px);
}

.info-card {
    background: #FEF3C7 !important;
    border: 1px solid #FCD34D !important;
    border-radius: 8px !important;
}

.info-row {
    margin-bottom: 0 !important;
}

.info-label {
    font-size: 0.75rem !important;
    font-weight: 600 !important;
    color: #37474f !important;
    letter-spacing: normal !important;
    text-transform: capitalize !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.info-value {
    font-size: 0.82rem !important;
    font-weight: 400 !important;
    color: #546e7a !important;
    letter-spacing: normal !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.final-score-bar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
    background: #FEF3C7;
    border-radius: 12px;
    padding: 12px 24px;
    margin-bottom: 24px;
    box-shadow: 0 2px 8px rgba(234, 179, 8, 0.25);
}

.final-score-label {
    font-size: 0.88rem;
    font-weight: 600;
    color: #92400E;
    letter-spacing: normal;
}

.final-score-value {
    font-size: 1.4rem;
    font-weight: 700;
    color: #1a3a5c;
    background: rgba(255,255,255,0.7);
    border-radius: 8px;
    padding: 2px 16px;
    letter-spacing: normal;
    min-width: 90px;
    text-align: center;
}

.fbtn {
    min-width: 90px !important;
    height: 36px !important;
    border-radius: 8px !important;
    font-size: 0.82rem !important;
    font-weight: 600 !important;
    text-transform: none !important;
    letter-spacing: 0.02em !important;
    box-shadow: none !important;
}

.fbtn-cancel {
    background: #F1F5F9 !important;
    color: #64748B !important;
}
.fbtn-cancel:hover {
    background: #E2E8F0 !important;
    color: #334155 !important;
}
</style>